// extracted by mini-css-extract-plugin
export default {"darkModeToggle":"dark_mode_darkModeToggle__VMaeb","graphic":"dark_mode_graphic__IRW1a","darkThemeGraphic":"dark_mode_darkThemeGraphic__NR05V"};